// eslint-disable-next-line no-restricted-imports
import { workspaceInterface } from './workspaceInterface';
import { workspaceInterface as workspaceInterfaceRegistry } from '@ardoq/workspace-interface';

export const initializeWorkspaceInterface = () => {
  workspaceInterfaceRegistry.registerImplementation(workspaceInterface);
};
